import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";

@Component({
    selector: "form-field-storybook",
    templateUrl: "./form-field-storybook.component.html",
})
export class FormFieldStorybookComponent implements OnInit {
    formFieldTypes = ["input", "textarea", "select"] as const;
    formFieldSizes = ["small", "medium", "large"] as const;

    // create a control with error state
    requiredControl = new FormControl(null, [Validators.email, Validators.required]);

    ngOnInit() {
        this.requiredControl.markAsTouched();
        this.requiredControl.updateValueAndValidity();
    }
}
